import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { AdminButton } from "../buttons/versionHistoryBtn";
import "./modal.css";
import PlaceOrderTable from "../tables/placeOrderTable";
import SendMailTableModal from "./sendMailCFAModal";

const PlaceOrderTableModal = ({ show, handleClose, orderProducts }) => {
  const [sendMailShow, setSendMailShow] = useState(false);
  const [mailData, setMailData] = useState([]);
  const updateCFAOrder = (e, ele) => {
    console.log(e.target.value, ele);
  };

  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      dialogClassName="distributor-reimburse-table-container"
      size="lg"
    >
      <ModalHeader>
        <span className="fn_Nunito fw_700 fs_16 Medium_Purple my- px-0">
          Place Order to CFA
        </span>
      </ModalHeader>

      <ModalBody>
        <div>
          <PlaceOrderTable
            orderProducts={orderProducts}
            updateCFAOrder={updateCFAOrder}
          />
        </div>
        <div className="d-flex justify-content-end mt-3">
          <AdminButton width="150px" background="#7065e4" color="white">
            <span
              className="m-2 btn-txt fs_12"
              onClick={() => setSendMailShow(true)}
            >
              Send mail
            </span>
          </AdminButton>

          <AdminButton
            width="100px"
            color="#FF6F5B"
            border="1px solid #FF6F5B"
            onClick={() => handleClose()}
          >
            <span className="m-1">CLOSE</span>
          </AdminButton>
        </div>
      </ModalBody>
      <SendMailTableModal
        sendMailShow={sendMailShow}
        mailData={mailData}
        handleSendMailShowClose={() => setSendMailShow(false)}
      />
    </Modal>
  );
};

export default PlaceOrderTableModal;
